// extracted by mini-css-extract-plugin
export default {"discover_page_title":"S1_Discover_discover_page_title__xf9Af","discover_page_line":"S1_Discover_discover_page_line__kYhNF"};